import * as React from 'react';
import {
    Stack,
    List,
    ListItem,
    ListItemText,
    Typography,
    useMediaQuery,
} from '@mui/material';

export default function CustomNoRowsOverlay() {
    const isIpad = useMediaQuery('(max-width: 1200px)');
    const isMobile = useMediaQuery('(max-width: 770px)');
    return (
        <Stack
            height={isMobile || isIpad ? '50%' : '100%'}
            alignItems='center'
            justifyContent='center'
        >
            <List>
                <ListItem
                    sx={{
                        textAlign: 'center',
                    }}
                >
                    <ListItemText
                        sx={{
                            textAlign: 'center',
                        }}
                        primary={
                            <img
                                alt='noresults'
                                src='/noResults.png'
                                style={{
                                    width:
                                        isMobile || isIpad ? '500px' : '500px',
                                    height: 'auto',
                                }}
                            />
                        }
                        secondary={<Typography>No Results</Typography>}
                    />
                </ListItem>
            </List>
        </Stack>
    );
}
